var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('b-button',{staticClass:"config",attrs:{"variant":"link"}},[_c('Config'),_vm._v(" Instrucciones: ¿Cómo completar esta sección?")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }